import { useSelector } from "react-redux";
import styled from "styled-components";
import { userColors } from "../../util/colors";
import HalligalliCard from "./HalligalliCard";
import React from "react";
import { BellIcon } from "../../icon/Icons";

const HalligalliUserRow = ({ indexArr, reverse }) => {
  const {
    halligalli: { halligalliUsers, turnUser, bellPress },
  } = useSelector(state => state.GameSlice);
  const { users } = useSelector(state => state.GameSlice);

  return (
    <PlayerRow>
      {indexArr.map((i, index) => {
        const userItem = halligalliUsers[i];

        const findUser = users.find(i => i?.userId === userItem?.userId);
        const checkEnd = userItem?.end;
        const userColor = userColors[findUser?.order] || "#fff";
        const checkTurn =
          turnUser.userId && turnUser?.userId === userItem?.userId;
        const background = checkTurn ? "#E7F1EC" : "#fff";
        const cellStyle = {
          background: `linear-gradient(135deg, ${userColor} 5px, ${background} 0)`,
          border: checkTurn && "1px solid #137E43",
        };
        const front = userItem?.front;
        const lastCard = front?.[front?.length - 1];
        const fruitToLabel = { banana: 1, strawberry: 2, lime: 3, cherry: 4 };
        const cardLabel = fruitToLabel[lastCard?.label];
        const pressItem = bellPress[0];

        return (
          <React.Fragment key={`halligalliUserKey${i}`}>
            {index !== 0 && (
              <PlayerItem $reverse={reverse}>
                <HalligalliCell />
                <HalligalliCell />
                <CardItem />
              </PlayerItem>
            )}
            <PlayerItem $reverse={reverse}>
              <HalligalliCell
                style={checkEnd ? { backgroundColor: "#f5f5f5" } : cellStyle}>
                {userItem?.nickname}
                {pressItem && pressItem?.userId === userItem?.userId && (
                  <BellItem>
                    <BellIcon />
                  </BellItem>
                )}
              </HalligalliCell>
              <HalligalliCell>
                {userItem ? `보유:${userItem?.cards?.length}개` : ""}
              </HalligalliCell>
              <CardItem>
                <HalligalliCard
                  label={cardLabel}
                  value={lastCard?.num}
                  id={i}
                />
                <FrontSpan $reverse={reverse}>
                  {front?.length && `${front?.length}개`}
                </FrontSpan>
                <BorderBox $onFront={front?.length} $onUser={userItem} />
              </CardItem>
            </PlayerItem>
          </React.Fragment>
        );
      })}
    </PlayerRow>
  );
};

export default HalligalliUserRow;

const HalligalliCell = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
`;

const PlayerItem = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  flex-direction: ${({ $reverse }) => ($reverse ? "column-reverse" : "column")};
  flex-basis: 20%;
`;
const BellItem = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  left: 50%;
  top: 50%;
  translate: -50% -50%;
  background-color: transparent;
`;

const CardItem = styled.div`
  width: 100%;
  height: 50%;

  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;

  padding: 3px 8px;
  background-color: #fff;
  position: relative;
`;
const FrontSpan = styled.span`
  color: #8a8a8a;
  position: absolute;
  font-size: 10px;
  left: 50%;

  ${({ $reverse }) =>
    $reverse
      ? "top:0; translate: -50% -105%;"
      : "bottom:0;translate: -50% 105%;"}
`;

const BorderBox = styled.div`
  width: 100%;
  height: 100%;
  border: ${({ $onUser, $onFront }) =>
    $onUser ? `1px solid ${$onFront ? "#8A8A8A" : "#E0E0E0"}` : null};
  position: absolute;
  left: 0;
  top: 0;
`;

const PlayerRow = styled.div`
  width: 100%;
  height: ${(100 / 11) * 4}%;
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  z-index: 1;
`;
